import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export const InstallButton = () => {
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setPrompt(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);
  if (!prompt) return null;
  return (
    <button className="nav-btn" data-testid="install-app-button" onClick={() => { prompt.prompt(); prompt.userChoice.finally(() => setPrompt(null)); }}>
      <Download size={18} /> Install app
    </button>
  );
};
